import { atom, useAtomValue, useSetAtom } from 'jotai';

export const conversationReadTimeMapState = atom<
  Record<Conversation.Conversation['conversationId'], number>
>({});

export const useConversationReadTimeMapValue = () => {
  return useAtomValue(conversationReadTimeMapState);
};

export const useSetConversationReadTimeMapValue = () => {
  return useSetAtom(conversationReadTimeMapState);
};
